import React from "react";

const SidePane: React.FC = ({ children }) => {
  return <div>{children}</div>;
};

export default SidePane;
